import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-cream-100 overflow-hidden pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-94">
      {/* Decorative Blobs */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-sage-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-95"></div>
      <div className="absolute top-0 left-0 -ml-20 -mt-20 w-72 h-72 bg-rose-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000" data-id="element-96"></div>
      <div className="absolute bottom-0 left-20 -mb-20 w-80 h-80 bg-beige-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-4000" data-id="element-97"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-98">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-99">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center lg:text-left" data-id="element-100">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-charcoal mb-6 leading-tight" data-id="element-101">
              Desinflama tu abdomen en 21 dias
            </h1>

            <p className="md:text-xl text-charcoal-light mb-8 max-w-2xl mx-auto lg:mx-0 text-[16px] font-[400] font-[Lato,_sans-serif]" data-id="element-102">
              Sin cardio intenso. Sin dietas extremas
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-103">
              <button onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} className="px-8 py-4 bg-sage-600 hover:bg-sage-700 text-white font-sans font-bold rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-lg" data-id="element-104">
                Empezar ahora
              </button>
              <button onClick={() => document.getElementById('problem')?.scrollIntoView({
              behavior: 'smooth'
            })} className="px-8 py-4 bg-white hover:bg-cream-50 text-sage-700 border-2 border-sage-200 font-sans font-bold rounded-full transition-colors flex items-center justify-center text-lg" data-id="element-105">
                ¿Cómo funciona?
              </button>
            </div>

            <p className="mt-4 text-sm text-charcoal-light opacity-80" data-id="element-106">
              *Acceso inmediato 6,99 $*
            </p>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-107">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-8 border-white" data-id="element-108">
              <img src="https://cdn.magicpatterns.com/uploads/czUVTnV3cf3N1YUgfTizDR/heylloyd-image-1772188307774.png" alt="Protocolo Vientre Plano 21D en tablet y móvil" className="w-full h-auto object-cover" data-id="element-109" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-110"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg border border-beige-200 hidden md:block animate-bounce-slow" data-id="element-111">
              <div className="flex items-center gap-3" data-id="element-112">
                <div className="w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center text-sage-600 font-bold text-xl" data-id="element-113">
                  21
                </div>
                <div data-id="element-114">
                  <p className="font-serif font-bold text-charcoal" data-id="element-115">Días</p>
                  <p className="text-xs text-charcoal-light" data-id="element-116">
                    Para transformar tu cuerpo
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}